// extracted by mini-css-extract-plugin
module.exports = {"error":"style_error__77cPb","note":"style_note__1fSJr","titleContainer":"style_titleContainer__jWNxz","title":"style_title__30UcC","detailLink":"style_detailLink__1eMfq"};